import { ClipboardCheckIcon, HeartHandIcon, SunIcon } from '@untitled-theme/icons-react'

import type { AdditionalService } from '../types/additional-services.types'

/**
 * Static content for the "Enter Zusatzleistungen" page.
 *
 * When services, prices or wording change, update the values here — the
 * layout is rendered by the AdditionalServicesPage components.
 */

export const ADDITIONAL_SERVICES_TITLE = {
  highlight: 'Enter',
  rest: 'Zusatzleistungen',
}

export const ADDITIONAL_SERVICES_SUBTITLE =
  'Weitere Services, die Sie auf Ihrem Weg zur energetischen Sanierung unterstützen.'

export const ADDITIONAL_SERVICES_SECTION_LABEL = 'Unsere Zusatzleistungen'

export const ADDITIONAL_SERVICES: AdditionalService[] = [
  {
    id: 'foerderservice',
    title: 'Förderservice',
    icon: ClipboardCheckIcon,
    subtitle: 'Wir betreuen Sie vom Fördercheck bis zur Auszahlung.',
    bullets: [
      'Für Maßnahmen an der Gebäudehülle und für den Heizungstausch',
      'Inklusive Antragstellung und Prüfung der Förderfähigkeit Ihres Angebots',
      'Persönliche Betreuung bis zur Auszahlung der Förderung',
    ],
    pricing: {
      label: 'Eigenanteil 495 €',
      detail: 'inkl. MwSt.',
    },
  },
  {
    id: 'pv-beratung',
    title: 'PV Beratung',
    icon: SunIcon,
    subtitle: 'Kostenfreie Erstberatung per Microsoft Teams.',
    bullets: [
      '30-minütiger Termin',
      'Berechnung des möglichen Ertrags auf Ihrer vorhandenen Dachfläche',
      'Individuelle Einschätzung zu Leistung & Wirtschaftlichkeit',
    ],
    pricing: {
      label: 'Kostenfrei',
      detail: 'unverbindlich & informativ',
    },
  },
  {
    id: 'angebotsservice',
    title: 'Angebotsservice',
    icon: HeartHandIcon,
    subtitle: 'Unser Partnernetzwerk für Ihre energetische Sanierung.',
    bullets: [
      'Partnernetz in ganz Deutschland für Wärmepumpen und Einblasdämmung',
      'Kostenfreie Angebotserstellung – je nach Ihrer Region',
      'Auf Wunsch Umsetzung mit unseren Partnern möglich',
    ],
    pricing: {
      label: 'Kostenfrei',
      detail: 'regional & unverbindlich',
    },
  },
]

export const ADDITIONAL_SERVICES_GOAL = {
  label: 'Unser Ziel:',
  text: 'Wir machen Energieberatung einfach, verständlich und umsetzbar – mit den passenden Services an Ihrer Seite.',
  tagline: 'Persönlich. Kompetent. Unabhängig.',
}
